import React from 'react'
import { Mark, Stack, Text } from '@mantine/core'

import { scriptStyles } from '@/components/Event/CrForm/components/ScriptBlock'
import {
  fillScript,
  ScriptLine,
  ScriptValues,
} from '@/components/Event/CrForm/stateRecordScripts'
import { Card } from '@/components/Event/Detail/components/Card'

const highlightPlaceholders = (text: string) =>
  text
    .split(/(\[[^\]]+\])/)
    .map((part, index) =>
      part.startsWith('[') ? <Mark key={index}>{part}</Mark> : part,
    )

export const StateScriptBlock: React.FC<{
  heading: string
  lines: ScriptLine[]
  values: ScriptValues
}> = ({ heading, lines, values }) => (
  <Card heading={heading}>
    <Stack spacing="sm">
      {lines.map((line, index) =>
        line.type === 'say' ? (
          <Text key={index} size="sm" color="gray.9" sx={scriptStyles}>
            {highlightPlaceholders(fillScript(line.text, values))}
          </Text>
        ) : (
          <Text key={index} size="sm" color="dimmed" fs="italic">
            {line.text}
          </Text>
        ),
      )}
    </Stack>
  </Card>
)
